import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_idprint } from "../shared/data.service";

import { wsPrintQueueInfo } from "../shared/wsPrintQueueInfo";
import { wsPrintSchoolPrinterInfo } from "../shared/wsPrintSchoolOptionsInfo";
import { wsPrintQueueSetPrinterParm } from "../shared/wsPrintQueueSetPrinterParm";
import { wsSetPrinterInfo } from "../shared/wsPrintQueueSetPrinterParm";

import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./setprinter.component.html",
	styleUrls: ["./setprinter.component.css"],
})
export class SetPrinterComponent implements OnInit, OnDestroy {
	constructor(private dataService: DataService_idprint, public ref: DynamicDialogRef, public dialogConfig: DynamicDialogConfig) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public lstPrintQueueChecked: wsPrintQueueInfo[] = [];
	public lstPrinter: wsPrintSchoolPrinterInfo[] = [];
	public SelectedPrinter: wsPrintSchoolPrinterInfo;

	public ItemsChangedMessage: string = "";
	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.lstPrintQueueChecked = this.dialogConfig.data.lstPrintQueueChecked;
		this.lstPrinter = this.dialogConfig.data.lstPrinter;

		this.ItemsChangedMessage = "A total of " + this.lstPrintQueueChecked.length + " item(s) will have their printer set.";

		this.lstPrinter.unshift({
			IDPrinterID: -1,
			PrinterName: "- No Printer Specified",
			ScanStation: "",
		});

		this.SelectedPrinter = this.lstPrinter[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrinterChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPrinterChange(value) {
		this.SelectedPrinter = value;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSetPrinter
	//
	//-----------------------------------------------------------------------------------------------------
	onSetPrinter() {
		let parms: wsPrintQueueSetPrinterParm = {
			IDPrinterID: this.SelectedPrinter.IDPrinterID,
			SetPrinterItems: [],
		};

		this.lstPrintQueueChecked.forEach((item) => {
			let r: wsSetPrinterInfo = {
				IDPrintQueueID: item.IDPrintQueueID,
			};

			parms.SetPrinterItems.push(r);
		});

		this.isBusy = true;
		this.dataService.IDPrintQueueSetPrinter(parms).subscribe((data) => this.IDPrintQueueSetPrinter_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IDPrintQueueSetPrinter_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	IDPrintQueueSetPrinter_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
